import React, { useContext } from "react";
import {
    CardWrapper,
    PanelTitleWrapper,
    PanelContentWrapper,
    RequestNumberWrapper,
    RequestContentWrapper,
    RequestInfoWrapper,
    RequesterInfoWrapper,
    WorkOrderTitle,
    WorkOrderStatus,
    Label,
    FileLinkWrapper
} from "./styled";
import { statuses } from "../consts";
import { ReactComponent as AttachImageIcon } from "assets/svgs/attach-image.svg";
import { AppContext } from "hocs/withAppContext";


const RequestCard = ({ request: req }) => {
    const { helpers: { date } } = useContext(AppContext);
    let requestStatus = req.currentStatus;
    if (req.cancelledRequest === "1") {
        requestStatus = 'rejected';
    }
    else if (req.isRequesting === "1") {
        requestStatus = 'requesting';
    }

    return <CardWrapper>
        <PanelTitleWrapper>
            <WorkOrderStatus className={req.currentStatus}>
                <span className={`circle ${req.currentStatus}`}/>
                {statuses[requestStatus]}
            </WorkOrderStatus>
            <Label>
                <p>Requested By</p>
                <a style={{ 'wordBreak': 'break-all' }}
                   href={`mailto:${req.requesterEmailAddress}`}>{req.requesterEmailAddress}</a>
            </Label>
        </PanelTitleWrapper>

        <PanelContentWrapper>
            <RequestNumberWrapper>
                {req.workOrderNumber && <span># {req.workOrderNumber}</span>}
            </RequestNumberWrapper>
            <RequestContentWrapper>
                <RequestInfoWrapper>
                    <WorkOrderTitle>{req.mainDescription}</WorkOrderTitle>
                    <pre>{req.note}</pre>
                    {req.completedImageFile &&
                    <FileLinkWrapper
                        target="_blank"
                        href={req.completedImageFile.url}>
                        <AttachImageIcon/>
                        <span>View Image</span>
                    </FileLinkWrapper>
                    }
                </RequestInfoWrapper>
                <RequesterInfoWrapper>
                    <div><Label><p>Requested</p><span>{date(req.createdAt)}</span></Label></div>
                    <div><Label><p>Last Updated</p><span>{date(req.updatedAt)}</span></Label></div>
                </RequesterInfoWrapper>
            </RequestContentWrapper>
        </PanelContentWrapper>
    </CardWrapper>;
};


export default RequestCard;
